'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z' });

var Mms = function Mms(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Mms = (0, _pure2.default)(Mms);
Mms.muiName = 'SvgIcon';

exports.default = Mms;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Mms.js
// module id = 2614
// module chunks = 0